import { tapFeedback } from "../feedback";
import { stepGoal } from "../../shared/stars";

/** − 90 + for a kid's goal, in steps of 5 between 50 and 100, with the exact number shown. */
export function GoalStepper({
  name,
  goal,
  busy,
  onChange,
}: {
  name: string;
  goal: number;
  busy: boolean;
  onChange: (next: number) => void;
}) {
  const down = stepGoal(goal, -1);
  const up = stepGoal(goal, 1);

  function press(next: number) {
    tapFeedback();
    onChange(next);
  }

  return (
    <div className="stepper" role="group" aria-label={`${name}'s goal`}>
      <button
        type="button"
        className="stepper__button"
        aria-label={`Lower ${name}'s goal to ${down}`}
        disabled={busy || down === goal}
        onClick={() => press(down)}
      >
        −
      </button>
      <output className="stepper__value" aria-live="polite">
        {goal}
      </output>
      <button
        type="button"
        className="stepper__button"
        aria-label={`Raise ${name}'s goal to ${up}`}
        disabled={busy || up === goal}
        onClick={() => press(up)}
      >
        +
      </button>
    </div>
  );
}
